export default __webpack_public_path__ + "static/media/app-store-el.2cee83a9.svg";